import { formatDateFront } from '../../utils';
import { BBadge } from '../ui/generic';
import { variant } from '../ui/generic/utils';
import { IconCheck } from '@tabler/icons-react';

const Contract = ({ training }) => {
  //Hide training if its secondary free
  if (training?.isSecondaryFreeTraining) return;
  return (
    <div
      className={
        'h-fit w-full rounded-2xl border border-slate-200 bg-gradient-to-r from-purple-400 to-purple-700 p-6 text-white'
      }
    >
      <div className={'flex h-full justify-between'}>
        <div className={'flex flex-col justify-between'}>
          <div className={'flex flex-col gap-6'}>
            <div className={'flex flex-col gap-1'}>
              <h5 className={'text-sx font-medium text-purple-200'}>Dossier N°{training.id}</h5>
              <p className={'text-lg leading-none font-semibold text-white'}>{training.category}</p>
            </div>
            <div className={'text-sm font-normal'}>
              <p>Fin de formation : {formatDateFront(training?.contract?.endAt)}</p>
              <p>Financement : {training.contract?.financedType?.type ?? 'Non spécifié'}</p>
            </div>
          </div>
        </div>
        <div>
          <BBadge size={'large'} rounded={variant.rounded.square} color={variant.color.green}>
            {training?.contract?.status ?? 'Prospect'}
            <IconCheck className={'size-4'} />
          </BBadge>
        </div>
      </div>
    </div>
  );
};

export default Contract;
